// Feature-Reifegrad (IdeenManager „Wichita", v3.129.0).
//
// Unterscheidet Features nach Reife, damit Nutzer sehen, ob etwas schon
// durchgetestet ist ('final') oder noch nicht vollständig ('beta'). Das ist
// bewusst NUR ein Hinweis — es gated KEINEN Zugriff (Zugriff bleibt hasFeature/
// hasModule). Die Idee: „der Nutzer kann es nutzen, muss aber wissen, dass es
// noch nicht vollständig getestet ist."
//
// Quelle der Wahrheit ist das Feld `maturity: 'beta'` am jeweiligen Eintrag in
// featureRegistry.js (Standard ohne Feld = 'final'). Ein Statuswechsel ist eine
// Entwicklungsentscheidung und passiert per Deploy, nicht zur Laufzeit — deshalb
// im Code und nicht in Firestore. Zusätzlich gelten Feature-Labor-Einträge
// (`lab: true`) immer als Beta.

export function isFeatureBeta(feature) {
  if (!feature) return false;
  return feature.maturity === 'beta' || feature.lab === true;
}

export function featureMaturity(feature) {
  return isFeatureBeta(feature) ? 'beta' : 'final';
}
